import React from 'react';
import fr from 'facet-rest';
import useUserContext from 'Context/UserContext';
import { QueryVal } from 'Helpers/Query';
import useComponentDidMount from 'Hooks/useComponentDidMount';

function init() {
  return {
    token: QueryVal('t'),
    isLoggingIn: false,
    error: false,
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'loginStarted': {
      return {
        ...state,
        isLoggingIn: true,
      };
    }
    case 'loginSucceeded': {
      return {
        ...state,
        isLoggingIn: false,
      };
    }
    case 'loginFailed': {
      return {
        ...state,
        isLoggingIn: false,
        error: action.error,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

export default function useLoginToken(args = {}) {
  const { userResource, handleUserUpdate } = useUserContext();
  const [state, dispatch] = React.useReducer(reducer, null, init);
  const { api } = args;

  async function validateLoginToken(token) {
    dispatch({ type: 'loginStarted' });
    try {
      let res = await api.checkPlanningAgreementToken(token);
      res = await fr.http.Get(res.data.relationships.user.links.related);
      handleUserUpdate(res);
      dispatch({ type: 'loginSucceeded' });
    } catch (err) {
      dispatch({ type: 'loginFailed', error: err });
    }
  }

  useComponentDidMount(() => {
    if (!state.token) {
      return;
    }
    if (!userResource) {
      validateLoginToken(state.token);
    }
  });

  return {
    isLoggingIn: state.isLoggingIn,
    error: state.error,
  };
}
